(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[655],{

/***/ 61311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




const IconGoogle = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", null, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fbc02d",
    d: "M44 20H24v8h11a12 12 0 11-3-13l6-6A20 20 0 004 24a20 20 0 1040-4z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#e53935",
    d: "M6 15l7 5a12 12 0 0119-5l6-6a20 20 0 00-32 6z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#4caf50",
    d: "M24 44c5 0 10-2 13-5l-6-5a12 12 0 01-18-6l-7 5c4 7 10 11 18 11z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#1565c0",
    d: "M44 20H24v8h11c0 2-2 4-4 6l6 5s7-5 7-15v-4z"
  }));
};

const ForwardRef = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconGoogle, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
  svgRef: ref
}, props)));
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 90655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LoginView_LoginView; },
  "t": function() { return /* binding */ federatedSignIn; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconNzxtLogo.js
var IconNzxtLogo = __webpack_require__(59665);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconGoogle.js
var IconGoogle = __webpack_require__(61311);
// EXTERNAL MODULE: ./framework/utils/errors.ts + 12 modules
var utils_errors = __webpack_require__(2063);
// EXTERNAL MODULE: ./framework/utils/use-action.tsx
var use_action = __webpack_require__(62253);
;// CONCATENATED MODULE: ./framework/commerce/use-resend-verify.tsx

var useResendVerify = use_action/* default */.Z;
/* harmony default export */ var use_resend_verify = (useResendVerify);

// EXTERNAL MODULE: ./framework/customer/use-customer.tsx + 1 modules
var use_customer = __webpack_require__(75524);
;// CONCATENATED MODULE: ./framework/auth/use-resend-verify.tsx
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/explicit-function-return-type */ 







var defaultOpts = {
    url: "/api/maxify/auth",
    method: "POST"
};
var fetcher = function(options, param, fetch) {
    var email = param.email;
    if (!email) {
        throw new utils_errors/* CommerceError */.yG({
            message: "An email is required to request verification link."
        });
    }
    return fetch((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultOpts, options), {
        body: {
            email: email
        }
    }));
};
function extendHook(customFetcher) {
    var useResendVerify = function() {
        var mutate = (0,use_customer/* default */.ZP)().mutate;
        var fn = use_resend_verify(defaultOpts, customFetcher);
        return (0,react.useCallback)(function() {
            var _signup = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(input) {
                var data;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return fn(input);
                        case 2:
                            data = _ctx.sent;
                            _ctx.next = 5;
                            return mutate();
                        case 5:
                            return _ctx.abrupt("return", data);
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            function signup(input) {
                return _signup.apply(this, arguments);
            }
            return signup;
        }(), [
            fn,
            mutate
        ]);
    };
    useResendVerify.extend = extendHook;
    return useResendVerify;
}
/* harmony default export */ var auth_use_resend_verify = (extendHook(fetcher));

// EXTERNAL MODULE: ./stores/use-ui-store/index.ts + 2 modules
var use_ui_store = __webpack_require__(86649);
// EXTERNAL MODULE: ./utils/hooks/index.ts + 16 modules
var hooks = __webpack_require__(83307);
;// CONCATENATED MODULE: ./framework/commerce/use-login.tsx

var useLogin = use_action/* default */.Z;
/* harmony default export */ var use_login = (useLogin);

;// CONCATENATED MODULE: ./framework/auth/use-login.tsx
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/explicit-function-return-type */ 







var use_login_defaultOpts = {
    url: "/api/maxify/auth",
    method: "PUT"
};
var use_login_fetcher = function(options, param, fetch) {
    var email = param.email, password = param.password, oauthUID = param.oauthUID;
    if (!(email && password)) {
        throw new utils_errors/* CommerceError */.yG({
            message: "An email and password are required to login."
        });
    }
    if (!oauthUID) {
        throw new utils_errors/* CommerceError */.yG({
            message: "Invalid request."
        });
    }
    return fetch((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, use_login_defaultOpts, options), {
        body: {
            email: email,
            password: password,
            oauthUID: oauthUID
        }
    }));
};
function use_login_extendHook(customFetcher) {
    var useLogin = function() {
        var mutate = (0,use_customer/* default */.ZP)().mutate;
        var fn = use_login(use_login_defaultOpts, customFetcher);
        return (0,react.useCallback)(function() {
            var _login = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(input) {
                var data;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return fn(input);
                        case 2:
                            data = _ctx.sent;
                            _ctx.next = 5;
                            return mutate();
                        case 5:
                            return _ctx.abrupt("return", data);
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            function login(input) {
                return _login.apply(this, arguments);
            }
            return login;
        }(), [
            fn,
            mutate
        ]);
    };
    useLogin.extend = use_login_extendHook;
    return useLogin;
}
/* harmony default export */ var auth_use_login = (use_login_extendHook(use_login_fetcher));

// EXTERNAL MODULE: ./constants/index.ts + 15 modules
var constants = __webpack_require__(47041);
// EXTERNAL MODULE: ./components/Button/index.ts + 3 modules
var Button = __webpack_require__(60820);
// EXTERNAL MODULE: ./components/ButtonLink/index.ts + 2 modules
var ButtonLink = __webpack_require__(82346);
// EXTERNAL MODULE: ./components/Input/index.ts + 2 modules
var Input = __webpack_require__(11282);
// EXTERNAL MODULE: ./components/Divider/index.ts + 2 modules
var Divider = __webpack_require__(96590);
// EXTERNAL MODULE: ./components/Checkmark/index.ts + 1 modules
var Checkmark = __webpack_require__(54038);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(26167);
;// CONCATENATED MODULE: ./components/Auth/LoginView/styles.ts


var relative = (0,tailwindcss_classnames/* classnames */.d)("relative");
var container = (0,tailwindcss_classnames/* classnames */.d)("ml-3", relative);
var flexCenter = (0,tailwindcss_classnames/* classnames */.d)("flex", "items-center");
var legalText = (0,tailwindcss_classnames/* classnames */.d)("text-xs", "px-6");
var textCenter = (0,tailwindcss_classnames/* classnames */.d)("text-center");
var bgWhite = (0,tailwindcss_classnames/* classnames */.d)("bg-white");
var bgGrey800 = (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-dark-grey-800");
var textWhite = (0,tailwindcss_classnames/* classnames */.d)("text-white");
var policyLink = (0,tailwindcss_classnames/* classnames */.d)("pl-0", "pr-0", "text-xs", "underline");
var loginLinksBase = (0,tailwindcss_classnames/* classnames */.d)("pl-0", "pr-0", "text-sm");
var loginNotficationLinks = (0,tailwindcss_classnames/* classnames */.d)("pl-1", "text-sm", "font-semibold", "hover:underline", "focus:underline", "inline-flex");
var alertLink = (0,tailwindcss_classnames/* classnames */.d)(loginNotficationLinks, "underline", "!text-white");
var loginSignUpWith = (0,tailwindcss_classnames/* classnames */.d)("ml-2");
var whiteLogo = (0,tailwindcss_classnames/* classnames */.d)(textWhite, "fill-current");
var logo = function(isInverted) {
    return (0,tailwindcss_classnames/* classnames */.d)("w-20", "h-6", "mx-auto", (0,_define_property/* default */.Z)({}, whiteLogo, isInverted));
};
var loginWrapper = function(isInverted) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)("flex", "flex-col", "justify-center", "py-8", "sm:px-6", "lg:px-8", (_obj = {}, (0,_define_property/* default */.Z)(_obj, bgGrey800, isInverted), (0,_define_property/* default */.Z)(_obj, bgWhite, !isInverted), _obj));
};
var standaloneWrapper = (0,tailwindcss_classnames/* classnames */.d)("flex", "flex-col", "justify-center", "py-8", "sm:px-6", "lg:px-8", "m-auto", "max-w-lg", "lg:py-12");
var loginTopCard = (0,tailwindcss_classnames/* classnames */.d)("sm:mx-auto", "sm:w-full", "sm:max-w-md");
var loginHeading = (0,tailwindcss_classnames/* classnames */.d)("mt-6", "text-center", "text-3xl", "font-extrabold", "text-nzxt-light-grey-800");
var loginSubheading = (0,tailwindcss_classnames/* classnames */.d)("text-center", "text-sm", "text-nzxt-light-grey-600", "w-max", "mx-auto", "flex", "items-center", "mt-4");
var loginBottomCard = (0,tailwindcss_classnames/* classnames */.d)("sm:mx-auto", "sm:w-full", "sm:max-w-md");
var loginFormWrapper = (0,tailwindcss_classnames/* classnames */.d)("pt-4", "md:pt-8", "sm:px-10");
var loginForm = (0,tailwindcss_classnames/* classnames */.d)("space-y-6", "mt-6");
var loginButtonWrapper = (0,tailwindcss_classnames/* classnames */.d)("flex", "justify-center", "w-full");
var loginButton = (0,tailwindcss_classnames/* classnames */.d)("w-full");
var loginCheckboxWrapper = (0,tailwindcss_classnames/* classnames */.d)(flexCenter, "justify-between");
var loginContinueWithWrapper = (0,tailwindcss_classnames/* classnames */.d)("mt-6");
var loginSocialSignInWrapper = (0,tailwindcss_classnames/* classnames */.d)("mt-6", "flex", "justify-center", "px-4", "sm:px-10");
var loginSvgContainer = (0,tailwindcss_classnames/* classnames */.d)("w-full", "inline-flex", "justify-center", "py-2", "border", "border-gray-300", "rounded-md", "shadow-sm", "bg-white", "text-nzxt-light-grey-600", "hover:bg-nzxt-light-grey-50");
var loginSvgStyles = (0,tailwindcss_classnames/* classnames */.d)("w-6", "h-6", "stroke-current", "text-nzxt-light-grey-600");
var loginSignUpWrapper = (0,tailwindcss_classnames/* classnames */.d)("mt-4", "flex", "items-center", "justify-center");
var loginSignUpText = function(isInverted) {
    return (0,tailwindcss_classnames/* classnames */.d)("mr-2", "text-sm", (0,_define_property/* default */.Z)({}, textWhite, isInverted));
};
var errorWrapper = (0,tailwindcss_classnames/* classnames */.d)("bg-error", "p-3", "rounded-md");
var errorMessage = (0,tailwindcss_classnames/* classnames */.d)("text-white", "text-sm", "font-semibold");
var loginSuccessWrapper = (0,tailwindcss_classnames/* classnames */.d)("m-16", "sm:mx-auto", "sm:w-full", "sm:max-w-md");
var checkMark = (0,tailwindcss_classnames/* classnames */.d)("w-16", "py-2", "mx-auto");
var styles_successMessage = function(isInverted) {
    return (0,tailwindcss_classnames/* classnames */.d)("mt-2", "text-center", "text-sm", "font-semibold", (0,_define_property/* default */.Z)({}, textWhite, isInverted));
};
var successButtonWrapper = (0,tailwindcss_classnames/* classnames */.d)(loginButtonWrapper, "mt-6");

;// CONCATENATED MODULE: ./components/Auth/LoginView/LoginView.tsx
/* eslint-disable react/jsx-no-useless-fragment */ /* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable @typescript-eslint/no-shadow */ /* eslint-disable no-useless-escape */ /* eslint-disable security/detect-unsafe-regex */ /* eslint-disable max-len */ 









// import { setUserEmailCookie } from '@utils/user-email-cookie';

// import useAuthStore from '@stores/use-auth-store';

// import GTM from '@utils/gtm';







// import CheckboxInput from '@components/CheckboxInput';


var federatedSignIn = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(provider, oauthUID, options) {
        var ref, _callbackUrl, callbackUrl, signInUrl, res, data, _url, url;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ref = options !== null && options !== void 0 ? options : {}, _callbackUrl = ref.callbackUrl, callbackUrl = _callbackUrl === void 0 ? window.location.href : _callbackUrl;
                    signInUrl = "/uaa/oidc/interaction/".concat(oauthUID, "/federated/").concat(provider);
                    _ctx.next = 4;
                    return fetch(signInUrl, {
                        method: "post",
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        },
                        body: new URLSearchParams((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                            callbackUrl: callbackUrl,
                            json: "true"
                        }))
                    });
                case 4:
                    res = _ctx.sent;
                    _ctx.next = 7;
                    return res.json();
                case 7:
                    data = _ctx.sent;
                    ;
                    url = (_url = data.url) !== null && _url !== void 0 ? _url : callbackUrl;
                    window.location.href = url;
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function federatedSignIn(provider, oauthUID, options) {
        return _ref.apply(this, arguments);
    };
}();
var LoginView = function(param) {
    var pageType = param.pageType, isInverted = param.isInverted;
    var ref;
    var ref1 = (0,router.useRouter)(), query = ref1.query, push = ref1.push;
    var slug = query.slug, rawClientId = query.client_id;
    var oauthUID = Array.isArray(slug) && slug.length === 2 ? slug[1] : undefined;
    var clientId = Array.isArray(rawClientId) ? rawClientId[0] : rawClientId;
    // const login = useAuthStore.useLogin();
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,react.useState)(false), showVerificationLink = ref3[0], setShowVerificationLink = ref3[1];
    var ref4 = (0,react.useState)(""), successMessage = ref4[0], setSuccessMessage = ref4[1];
    var ref5 = (0,react.useState)(""), resendEmailVerificationSuccesMessage = ref5[0], setResendEmailVerificationSuccesMessage = ref5[1];
    var ref6 = (0,react.useState)(pageType === "modal" ? window.location.href : "https://nzxt.com"), callbackUrl = ref6[0], setCallbackUrl = ref6[1];
    // const { isLoggedIn } = useAuth();
    var logIn = auth_use_login();
    var setModalView = (0,use_ui_store/* default */.ZP)(use_ui_store/* getSetModalView */.Bz);
    var closeModal = (0,use_ui_store/* default */.ZP)(use_ui_store/* getCloseModal */.MK);
    // const modalAction = useUiStore(getModalAction);
    var setModalOnCloseAction = (0,use_ui_store/* default */.ZP)(use_ui_store/* getSetModalOnCloseAction */.NX);
    var resendEmailVerification = auth_use_resend_verify();
    var f = (0,hooks/* useFormatMessage */.LP)();
    var ref7 = (0,index_esm/* useForm */.cI)({
        mode: "onBlur"
    }), register = ref7.register, handleSubmit = ref7.handleSubmit, getValues = ref7.getValues, clearErrors = ref7.clearErrors, setError = ref7.setError, formState = ref7.formState, reset = ref7.reset;
    var isDirty = formState.isDirty, isSubmitted = formState.isSubmitted, errors = formState.errors;
    (0,react.useEffect)(function() {
        if (isDirty && isSubmitted && errors.serverError) {
            clearErrors("serverError");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDirty,
        isSubmitted,
        errors
    ]);
    var ref8 = (0,react.useState)(null), delay = ref8[0], setDelay = ref8[1];
    var successDelayCallback = function() {
        /*
      if (pageType === 'modal') {
        modalAction();
      }
      */ if (callbackUrl !== window.location.href) {
            push(callbackUrl);
        }
    };
    (0,hooks/* useTimeout */.KS)(successDelayCallback, delay);
    setModalOnCloseAction(successDelayCallback);
    (0,react.useEffect)(function() {
        if (query.callbackUrl) {
            setCallbackUrl(Array.isArray(query.callbackUrl) ? query.callbackUrl[0] : query.callbackUrl);
        }
    }, [
        query.callbackUrl
    ]);
    /*
  const gtmConfigAccountLogin = (): void => {
    const invalidUrl = [`/${ROUTE_CATEGORY}/gaming-pcs/`];
    const validUrl = [
      `/${ROUTE_BUILD}`,
      `${ROUTE_BUILD}/${ROUTE_BUILD_PC}/`,
      `/${ROUTE_BUILD}/${ROUTE_BUILD_PC}/${query}/`,
      `/${ROUTE_BUILD}/${ROUTE_BUILD_KEYBOARD}/`,
      `/${ROUTE_BUILD}/${ROUTE_BUILD_KEYBOARD}/${query}/`,
    ];

    const isValidPath = validUrl.some(currentPage =>
      asPath.includes(currentPage)
    );
    const isInValidPath = invalidUrl.some(currentPage =>
      asPath.includes(currentPage)
    );

    if (!isValidPath) {
      return;
    }
    if (isInValidPath) {
      return;
    }
    GTM.dataLayer({
      dataLayer: {
        event: 'Config_AccountLogin',
      },
    });
  };
  */ var resendEmailVerificationHandler = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var email, errors, errorMessage, errorMessageKey, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        email = getValues("email");
                        _ctx.prev = 1;
                        setLoading(true);
                        _ctx.next = 5;
                        return resendEmailVerification({
                            email: email
                        });
                    case 5:
                        clearErrors();
                        setResendEmailVerificationSuccesMessage(f("user_sign_up_check_email_message"));
                        setSuccessMessage(f("user_sign_up_success_verify_message"));
                        _ctx.next = 17;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](1);
                        errors = _ctx.t0.errors;
                        errorMessage = f("error_generic");
                        errorMessageKey = (0,utils_errors/* getErrorMessageKey */.H4)(errors);
                        if (errorMessageKey) {
                            ;
                            (ref = window.heap) === null || ref === void 0 ? void 0 : ref.track(errorMessageKey);
                            errorMessage = f(errorMessageKey);
                        }
                        setError("serverError", {
                            type: "error",
                            message: errorMessage
                        });
                    case 17:
                        _ctx.prev = 17;
                        setShowVerificationLink(false);
                        setLoading(false);
                        return _ctx.finish(17);
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    10,
                    17,
                    21
                ]
            ]);
        }));
        return function resendEmailVerificationHandler() {
            return _ref.apply(this, arguments);
        };
    }();
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            var res, errors, ref, errorMessage, errorMessageKey, ref1, formValues;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setLoading(true);
                        _ctx.next = 4;
                        return logIn({
                            // redirect: false,
                            // callbackUrl,
                            email: data.email,
                            password: data.password,
                            remember_me: data.remember_me,
                            oauthUID: oauthUID
                        });
                    case 4:
                        res = _ctx.sent;
                        clearErrors();
                        setShowVerificationLink(false);
                        setLoading(false);
                        // gtmConfigAccountLogin();
                        setSuccessMessage(f("user_login_success_message"));
                        setCallbackUrl(res.redirectTo);
                        // setUserEmailCookie(data.email);
                        if (pageType !== "modal") {
                            setDelay(2000);
                        }
                        _ctx.next = 25;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        errors = _ctx.t0.errors;
                        ;
                        errorMessage = f("error_generic");
                        errorMessageKey = (0,utils_errors/* getErrorMessageKey */.H4)(errors);
                        if (errorMessageKey) {
                            ;
                            (ref1 = window.heap) === null || ref1 === void 0 ? void 0 : ref1.track(errorMessageKey);
                            errorMessage = f(errorMessageKey);
                        }
                        formValues = getValues();
                        // react-hook-form doesn't support dirtySinceLastSubmit so have to reset
                        reset(formValues);
                        setError("serverError", {
                            type: "error",
                            message: errorMessage
                        });
                        if ((errors === null || errors === void 0 ? void 0 : (ref = errors[0]) === null || ref === void 0 ? void 0 : ref.code) === utils_errors/* ERROR_CODES.EmailNotVerified */.O1.EmailNotVerified) {
                            setShowVerificationLink(true);
                        } else {
                            setShowVerificationLink(false);
                        }
                        setLoading(false);
                    case 25:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }));
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var MESSAGE_INVALID_EMAIL = (0,hooks/* useTranslation */.$G)("invalid_email");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: pageType === "standalone" ? standaloneWrapper : loginWrapper(isInverted),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: loginTopCard,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconNzxtLogo/* default */.Z, {
                    className: logo(isInverted)
                })
            }),
            successMessage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: loginSuccessWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: checkMark,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkmark/* default */.Z, {})
                    }),
                    resendEmailVerificationSuccesMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: styles_successMessage(isInverted),
                        children: resendEmailVerificationSuccesMessage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: styles_successMessage(isInverted),
                        children: successMessage
                    }),
                    pageType === "modal" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: successButtonWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            type: "button",
                            buttonStyle: "primary",
                            onClick: function() {
                                return closeModal();
                            },
                            children: (0,hooks/* useTranslation */.$G)("ok")
                        })
                    })
                ]
            }),
            !successMessage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: loginBottomCard,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: loginSocialSignInWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                            type: "button",
                            buttonStyle: "textButton",
                            className: loginSvgContainer,
                            "data-test-id": "google-sign-in",
                            onClick: function() {
                                return federatedSignIn("google", oauthUID, {
                                    callbackUrl: callbackUrl
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconGoogle/* default */.Z, {
                                    className: loginSvgStyles
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: loginSignUpWith,
                                    children: (0,hooks/* useTranslation */.$G)("user_login_text")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: loginFormWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                text: (0,hooks/* useTranslation */.$G)("user_email_sign_in"),
                                isInverted: isInverted
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                className: loginForm,
                                onSubmit: handleSubmit(onSubmit),
                                children: [
                                    errors.serverError && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: errorWrapper,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: errorMessage,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    (ref = errors.serverError) === null || ref === void 0 ? void 0 : ref.message,
                                                    showVerificationLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        type: "button",
                                                        buttonStyle: "textButton",
                                                        className: alertLink,
                                                        onClick: resendEmailVerificationHandler,
                                                        children: (0,hooks/* useTranslation */.$G)("here")
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            "data-test-id": "email",
                                            type: "email",
                                            autoComplete: "email",
                                            inputLabel: (0,hooks/* useTranslation */.$G)("label_email_address"),
                                            labelFor: "emailAddress"
                                        }, register("email", {
                                            required: true,
                                            // eslint-disable-next-line
                                            pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                                        })), {
                                            requiredError: errors.email && errors.email.type === "required",
                                            patternError: errors.email && errors.email.type === "pattern" && MESSAGE_INVALID_EMAIL,
                                            isInverted: isInverted
                                        }))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            "data-test-id": "password",
                                            type: "password",
                                            autoComplete: "current-password",
                                            inputLabel: (0,hooks/* useTranslation */.$G)("label_password"),
                                            labelFor: "password"
                                        }, register("password", {
                                            required: true
                                        })), {
                                            requiredError: errors.password && errors.password.type === "required",
                                            isInverted: isInverted
                                        }))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: loginCheckboxWrapper,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: pageType === "standalone" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                                                href: "/".concat(constants/* ROUTE_OAUTH */.Ggo, "/forgot-password"),
                                                className: loginLinksBase,
                                                internalLink: true,
                                                children: (0,hooks/* useTranslation */.$G)("user_login_forgot_password")
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                type: "button",
                                                buttonStyle: "textButton",
                                                className: loginLinksBase,
                                                onClick: function() {
                                                    return setModalView("FORGOT_VIEW");
                                                },
                                                children: (0,hooks/* useTranslation */.$G)("user_login_forgot_password")
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: loginButtonWrapper,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            type: "submit",
                                            buttonStyle: "primary",
                                            loading: loading,
                                            className: loginButton,
                                            children: (0,hooks/* useTranslation */.$G)("user_sign_in")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: loginContinueWithWrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: loginSignUpWrapper,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: loginSignUpText(isInverted),
                                            children: (0,hooks/* useTranslation */.$G)("user_no_account")
                                        }),
                                        pageType === "standalone" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                                            href: "/".concat(constants/* ROUTE_OAUTH */.Ggo, "/signup/").concat(clientId ? "?client_id=".concat(clientId) : ""),
                                            className: loginLinksBase,
                                            internalLink: true,
                                            children: (0,hooks/* useTranslation */.$G)("user_create_account")
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            type: "button",
                                            buttonStyle: "textButton",
                                            onClick: function() {
                                                return setModalView("SIGNUP_VIEW");
                                            },
                                            className: loginLinksBase,
                                            children: (0,hooks/* useTranslation */.$G)("user_create_account")
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var LoginView_LoginView = (/*#__PURE__*/(0,react.memo)(LoginView));


/***/ }),

/***/ 60820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconLoading.js
var IconLoading = __webpack_require__(2017);
;// CONCATENATED MODULE: ./components/Button/ForwardRefBase.tsx




var ForwardRefBaseButton = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref,
        // eslint-disable-next-line react/button-has-type
        type: props.type
    }, props), {
        children: props.children
    }));
});
/* harmony default export */ var ForwardRefBase = (/*#__PURE__*/(0,react.memo)(ForwardRefBaseButton));

// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(26167);
;// CONCATENATED MODULE: ./components/Button/styles.ts


var defaultMargin = (0,tailwindcss_classnames/* classnames */.d)("mr-2");
var styles_button = function(customMargin) {
    return (0,tailwindcss_classnames/* classnames */.d)("min-w-max", "flex", "items-center", "font-medium", "transition", "disabled:cursor-not-allowed", "h-11", (0,_define_property/* default */.Z)({}, defaultMargin, !customMargin));
};
var buttonModeLight = {
    primary: (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-volt-400", "hover:bg-nzxt-volt-500", "disabled:text-nzxt-light-grey-500", "disabled:bg-nzxt-light-grey-300", "px-4", "text-base", "rounded-md", "justify-center", "min-w-120", "md:min-w-140", "text-white"),
    secondary: (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-dark-grey-400", "hover:bg-nzxt-dark-grey-500", "active:bg-nzxt-dark-grey-700", "disabled:text-nzxt-light-grey-500", "disabled:bg-nzxt-light-grey-300", "px-4", "text-base", "text-white", "rounded-md", "justify-center", "min-w-120", "md:min-w-140"),
    danger: (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-red-200", "text-white", "hover:bg-nzxt-red-100", "disabled:text-nzxt-light-grey-500", "disabled:bg-nzxt-light-grey-300", "px-4", "text-base", "rounded-md", "justify-center", "min-w-120", "md:min-w-140"),
    textButton: (0,tailwindcss_classnames/* classnames */.d)("text-blue-600", "hover:underline", "disabled:text-nzxt-light-grey-500", "underline-offset")
};
var buttonModeDark = {
    primary: (0,tailwindcss_classnames/* classnames */.d)("border-white", "border-2", "text-white", "disabled:border-transparent", "disabled:text-nzxt-light-grey-500", "disabled:bg-nzxt-light-grey-300", "px-4", "rounded-md", "justify-center", "min-w-120", "md:min-w-140"),
    secondary: (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-dark-grey-500", "hover:bg-nzxt-dark-grey-600", "disabled:text-nzxt-light-grey-500", "disabled:bg-nzxt-light-grey-300", "px-4", "text-base", "rounded-md", "justify-center", "min-w-120", "md:min-w-140"),
    danger: (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-red-100", "text-white", "hover:bg-nzxt-red-200", "disabled:text-nzxt-light-grey-500", "disabled:bg-nzxt-light-grey-300", "px-4", "text-base", "rounded-md", "justify-center", "min-w-120", "md:min-w-140"),
    textButton: (0,tailwindcss_classnames/* classnames */.d)("text-blue-600", "hover:underline", "disabled:text-nzxt-light-grey-500", "underline-offset")
};

// EXTERNAL MODULE: ./components/Button/buttonStyles.module.css
var buttonStyles_module = __webpack_require__(11892);
var buttonStyles_module_default = /*#__PURE__*/__webpack_require__.n(buttonStyles_module);
;// CONCATENATED MODULE: ./components/Button/Button.tsx











// TODO: The forward ref has the following type error:
// Type 'LegacyRef<HTMLButtonElement>' is not assignable to type 'Ref<HTMLButtonElement>'.
// Type 'string' is not assignable to type 'Ref<HTMLButtonElement>'.ts(2322)
// It is unclear why this issue is persisting @Donny @Tatiana
var Button = function(_param) {
    var children = _param.children, buttonStyle = _param.buttonStyle, className = _param.className, dark = _param.dark, type = _param.type, loading = _param.loading, customMargin = _param.customMargin, buttonRef = _param.buttonRef, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "buttonStyle",
        "className",
        "dark",
        "type",
        "loading",
        "customMargin",
        "buttonRef"
    ]);
    var isText = buttonStyle.includes("text");
    var composedClassName = (0,react.useMemo)(function() {
        return (0,clsx_m/* default */.Z)(styles_button(customMargin), dark ? buttonModeDark[buttonStyle] : buttonModeLight[buttonStyle], className, (0,_define_property/* default */.Z)({}, (buttonStyles_module_default()).btn, !isText));
    }, [
        buttonStyle,
        className,
        dark,
        customMargin,
        isText
    ]);
    return buttonRef ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ForwardRefBase, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        // eslint-disable-next-line
        // @ts-ignore
        ref: buttonRef,
        className: composedClassName,
        type: type
    }, rest), {
        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconLoading/* default */.Z, {
            className: "loading-icon"
        }) : children
    })) : // eslint-disable-next-line
    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: composedClassName,
        type: type
    }, rest), {
        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconLoading/* default */.Z, {
            className: "loading-icon"
        }) : children
    }));
};
/* harmony default export */ var Button_Button = (/*#__PURE__*/(0,react.memo)(Button));

;// CONCATENATED MODULE: ./components/Button/index.ts

/* harmony default export */ var components_Button = (Button_Button);


/***/ }),

/***/ 54038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Checkmark; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/LottieControl/index.ts + 1 modules
var LottieControl = __webpack_require__(37556);
;// CONCATENATED MODULE: ./components/Checkmark/Checkmark.tsx



var Checkmark = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LottieControl/* default */.Z, {
        src: "/animations/4964-check-mark-success-animation.json"
    });
};
/* harmony default export */ var Checkmark_Checkmark = (Checkmark);

;// CONCATENATED MODULE: ./components/Checkmark/index.ts

/* harmony default export */ var components_Checkmark = (Checkmark_Checkmark);


/***/ }),

/***/ 96590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Divider; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(26167);
;// CONCATENATED MODULE: ./components/Divider/styles.ts


var relative = (0,tailwindcss_classnames/* classnames */.d)("relative");
var flexCenter = (0,tailwindcss_classnames/* classnames */.d)("flex", "items-center");
var dividerWrapper = (0,tailwindcss_classnames/* classnames */.d)("absolute", "inset-0", flexCenter);
var divider = (0,tailwindcss_classnames/* classnames */.d)("w-full", "border-t", "border-gray-300");
var dividerTextWrapper = (0,tailwindcss_classnames/* classnames */.d)("relative", "flex", "justify-center", "text-sm");
var lightDivider = (0,tailwindcss_classnames/* classnames */.d)("bg-white", "text-gray-500");
var darkDivider = (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-dark-grey-800", "text-white");
var dividerText = function(isInverted) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)("px-2", (_obj = {}, (0,_define_property/* default */.Z)(_obj, darkDivider, isInverted), (0,_define_property/* default */.Z)(_obj, lightDivider, !isInverted), _obj));
};

;// CONCATENATED MODULE: ./components/Divider/Divider.tsx



var Divider = function(param) {
    var text = param.text, isInverted = param.isInverted;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: relative,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: dividerWrapper,
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: divider
                })
            }),
            text && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: dividerTextWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: dividerText(isInverted),
                    children: text
                })
            })
        ]
    });
};
/* harmony default export */ var Divider_Divider = (/*#__PURE__*/(0,react.memo)(Divider));

;// CONCATENATED MODULE: ./components/Divider/index.ts

/* harmony default export */ var components_Divider = (Divider_Divider);


/***/ }),

/***/ 11282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Input; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/hooks/index.ts + 16 modules
var hooks = __webpack_require__(83307);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(26167);
;// CONCATENATED MODULE: ./components/Input/styles.ts


var srOnly = "mt-2.5";
var darkInput = (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-dark-grey-700", "border-nzxt-dark-grey-700");
var input = function(isSrOnly, isInverted) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)((_obj = {}, (0,_define_property/* default */.Z)(_obj, srOnly, !isSrOnly), (0,_define_property/* default */.Z)(_obj, darkInput, isInverted), _obj), "focus:ring", "outline-none", "focus:outline-none", "focus:shadow-none", "focus:ring-nzxt-volt-400", "focus:ring-1", "focus:border-nzxt-volt-400", "appearance-none", "block", "w-full", "px-3", "py-2", "border", "border-gray-300", "rounded-md", "shadow-sm", "placeholder-gray-400", "sm:text-sm");
};
var textWhite = (0,tailwindcss_classnames/* classnames */.d)("text-white");
var textGray700 = (0,tailwindcss_classnames/* classnames */.d)("text-gray-700");
var styles_inputLabel = function(isInverted) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)("block", "text-sm", "font-medium", "focus:outline-none", (_obj = {}, (0,_define_property/* default */.Z)(_obj, textWhite, isInverted), (0,_define_property/* default */.Z)(_obj, textGray700, !isInverted), _obj));
};
var errorText = (0,tailwindcss_classnames/* classnames */.d)("text-red-500", "mt-2", "text-xs");
var styles_patternMessage = (0,tailwindcss_classnames/* classnames */.d)("mt-2", "text-xs");

;// CONCATENATED MODULE: ./components/Input/Input.tsx
/* eslint-disable @typescript-eslint/no-explicit-any */ 






var Input = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var classes = _param.classes, labelFor = _param.labelFor, inputLabel = _param.inputLabel, srOnlyLabel = _param.srOnlyLabel, requiredError = _param.requiredError, generalError = _param.generalError, patternError = _param.patternError, patternMessage = _param.patternMessage, customLabelStyling = _param.customLabelStyling, isInverted = _param.isInverted, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "classes",
        "labelFor",
        "inputLabel",
        "srOnlyLabel",
        "requiredError",
        "generalError",
        "patternError",
        "patternMessage",
        "customLabelStyling",
        "isInverted"
    ]);
    var rootClassName = (0,clsx_m/* default */.Z)(input(srOnlyLabel, isInverted), {}, classes === null || classes === void 0 ? void 0 : classes.inputClass);
    var labelClassName = (0,clsx_m/* default */.Z)(styles_inputLabel(isInverted), {}, classes === null || classes === void 0 ? void 0 : classes.labelClass);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
        htmlFor: labelFor,
        className: customLabelStyling || labelClassName,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: srOnlyLabel ? "sr-only" : null,
                children: inputLabel
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                id: labelFor,
                className: rootClassName,
                ref: ref
            }, rest)),
            patternMessage && !generalError && !patternError && !requiredError && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: styles_patternMessage,
                children: patternMessage
            }),
            requiredError && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: errorText,
                children: (0,hooks/* useTranslation */.$G)("field_required_message")
            }),
            (generalError || patternError) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: errorText,
                children: generalError || patternError
            })
        ]
    });
});
/* harmony default export */ var Input_Input = (/*#__PURE__*/(0,react.memo)(Input));

;// CONCATENATED MODULE: ./components/Input/index.ts

/* harmony default export */ var components_Input = (Input_Input);


/***/ }),

/***/ 37556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_LottieControl; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/LottieControl/LottieControl.tsx





var LottieControl = function(param) {
    var src = param.src, _loop = param.loop, loop = _loop === void 0 ? false : _loop;
    var ref = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), playerLoaded = ref1[0], setPlayerLoaded = ref1[1];
    react.useEffect(function() {
        var loadLottiePlayer = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return __webpack_require__.e(/* import() */ 1807).then(__webpack_require__.bind(__webpack_require__, 70886));
                        case 2:
                            setPlayerLoaded(true);
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function loadLottiePlayer() {
                return _ref.apply(this, arguments);
            };
        }();
        loadLottiePlayer();
    }, []);
    return playerLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)("lottie-player", (0,_object_spread/* default */.Z)({
        ref: ref,
        autoplay: true,
        mode: "normal",
        src: src
    }, loop && {
        loop: true
    }));
};
/* harmony default export */ var LottieControl_LottieControl = (/*#__PURE__*/(0,react.memo)(LottieControl));

;// CONCATENATED MODULE: ./components/LottieControl/index.ts

/* harmony default export */ var components_LottieControl = (LottieControl_LottieControl);


/***/ }),

/***/ 11892:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btn":"buttonStyles_btn__EKYZF"};

/***/ })

}]);